import { Box, Divider } from '@wix/design-system';
import React, { useCallback } from 'react';
import { RuleFooter } from '../../../rule-layout';
import { AiDisclaimerBanner } from '../../shared';
import { useSharedAltTextScreenContext } from '../context/alt-text-screen-context';
import { useStopGeneratingGuard } from '../hooks/use-stop-generating-guard';
export const AltTextScreenFooter = _ref => {
  let {
    cancelButtonType = 'button',
    designProps,
    applyPopoverContent,
    showApplyPopover = false
  } = _ref;
  const {
    actions,
    state,
    translations,
    biCallbacks
  } = useSharedAltTextScreenContext();
  const {
    onApply,
    onCancel
  } = actions;
  const {
    isLoading,
    showAiWarning
  } = state;
  const isApplyDisabled = state.isApplyDisabled ?? false;
  const {
    aiWarningText,
    applyLabel,
    cancelLabel
  } = translations;
  const {
    guard
  } = useStopGeneratingGuard();
  const handleCancel = useCallback(() => {
    guard(() => {
      biCallbacks.onCancelClick();
      onCancel();
    });
  }, [guard, biCallbacks, onCancel]);
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "alt-text-footer-container",
    direction: "vertical",
    flex: "0 0 auto",
    width: "100%",
    zIndex: "10"
  }, /*#__PURE__*/React.createElement(Divider, null), showAiWarning && aiWarningText && /*#__PURE__*/React.createElement(AiDisclaimerBanner, {
    dataHook: "alt-text-footer-ai-warning",
    text: aiWarningText,
    variant: "footer"
  }), /*#__PURE__*/React.createElement(Box, {
    align: "right",
    padding: "16px 24px"
  }, /*#__PURE__*/React.createElement(RuleFooter, {
    dataHook: "alt-text-footer-buttons",
    design: {
      buttonSize: designProps == null ? void 0 : designProps.buttonSize
    },
    dismissButtonProps: {
      label: cancelLabel,
      onClick: handleCancel,
      type: cancelButtonType
    },
    submitButtonProps: {
      disabled: isApplyDisabled,
      label: applyLabel,
      onClick: () => {
        biCallbacks.onApplyClick();
        onApply();
      },
      popoverContent: applyPopoverContent,
      showLoader: isLoading,
      showPopover: showApplyPopover
    }
  })));
};
//# sourceMappingURL=alt-text-screen-footer.js.map